import { render, staticRenderFns } from "./MicroLesson.vue?vue&type=template&id=dc94d21e&scoped=true&"
import script from "./MicroLesson.vue?vue&type=script&lang=js&"
export * from "./MicroLesson.vue?vue&type=script&lang=js&"
import style0 from "./MicroLesson.vue?vue&type=style&index=0&id=dc94d21e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc94d21e",
  null
  
)

export default component.exports